import React from "react";
import { useAppContext } from "../../AppProvider";
import InputBoxIcon from "../../Components/Inputs/InputIcon/InputIcon";
import { Parcel } from "../../Models/Parcel";
import {
  faCube,
  faRuler,
  faRulerHorizontal,
  faRulerVertical,
  faWeightHanging,
} from "../../utilities/fontawesomeIcons";
import "./Layout/index.scss";
import { getParcelsListGridLayout } from "./Layout";
import { createParcelsListGridVars } from "./Layout/gridVars";

export const ParcelListItem: React.FC<{
  listRef: React.RefObject<{
    refresh: () => void;
  } | null>;
  item: Parcel;
  index: number;
}> = React.memo(({ item }) => {
  const { dictionary, display } = useAppContext();

  const parcelsListLayout = getParcelsListGridLayout(display);
  const parcelsListStyle = createParcelsListGridVars(parcelsListLayout);

  return (
    <>
      <div
        data-grid-template="parcelsList"
        className="d-grid gap-2 rounded-2 p-2 align-items-center mb-2"
        style={parcelsListStyle}
      >
        <div data-grid-area="internalReference">
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.references.internal_reference}
            </label>
          )}
          <InputBoxIcon
            name="internalReference"
            value={item.internalReference || "-"}
            type="text"
            disabled
          />
        </div>
        <div data-grid-area="width">
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.dimensions.width + " (cm)"}
            </label>
          )}
          <InputBoxIcon
            name="width"
            value={item.width || 0}
            type="positive-number"
            placeholder="10.00"
            icon={faRulerHorizontal}
            disabled
          />
        </div>
        <div data-grid-area="length">
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.dimensions.length} (cm)
            </label>
          )}
          <InputBoxIcon
            name="length"
            value={item.length || 0}
            type="positive-number"
            min={0}
            placeholder="10.00"
            icon={faRuler}
            disabled
          />
        </div>
        <div data-grid-area="height">
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.dimensions.height} (cm)
            </label>
          )}
          <InputBoxIcon
            name="height"
            value={item.height || 0}
            type="positive-number"
            min={0}
            placeholder="10.00"
            icon={faRulerVertical}
            disabled
          />
        </div>
        <div data-grid-area="weight">
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.dimensions.weight} (Kg)
            </label>
          )}
          <InputBoxIcon
            name="weight"
            value={item?.weight || 0}
            type="positive-number"
            icon={faWeightHanging}
            disabled
          />
        </div>
        <div data-grid-area="volume">
          {(display.xs || display.sm || display.md) && (
            <label className="label-2">
              {dictionary.dimensions.volume} (m<sup>3</sup>)
            </label>
          )}
          <InputBoxIcon
            name="volume"
            value={item?.volume || 0}
            type="positive-number"
            precision={6}
            icon={faCube}
            disabled
          />
        </div>
      </div>
    </>
  );
});
